export enum WidgetTypes {
    Table,
    Analyse,
    Text,
    Image,
    Links,
    WhoIsOnline,
    Lists,
    DesignTable,
    MeasureText,
    DesignMeasureText,
    MeasuresByCategory,
    Statistic,
    MeasureTree,
    MeasuresByStatus,
    HasMeasures,
    GenericDataTable,
    VideoTutorials,
    Dashboard,
    NewestDocuments,
    UserIsNamed
}